var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.legalText)?_c('TypeBody',{staticClass:"mt-6 text-center text-base-700",attrs:{"variant":"caption","weight":"medium","tag":"div"}},[_vm._v("\n  "+_vm._s(_vm.legalText)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }